import App from "./App.tsx";
import register from "preact-custom-element";

register(App, "gerl-benning-tester-hub", ["token", "size"], { shadow: true });
